// import { RUPEE_SYMBOL } from "Poker/data/Constants";

export const transformStats = (data, config) => {
  if (!data || Object.keys(data).length === 0) return [];
  return config
    .map(({ key, label, format, calculate, valueClass = "", show }) => {
      const rawValue = calculate ? calculate(data) : data?.[key];
      if (typeof show === "function" && !show(rawValue, data)) {
        return null;
      }
      return {
        label,
        value: format ? format(rawValue, data) : rawValue,
        valueClass,
      };
    })
    .filter(Boolean);
};

export const convertMinsToHours = (mins) => {
  if (typeof mins !== "number" || isNaN(mins) || mins < 0) {
    return "0 Mins";
  }
  const hours = Math.floor(mins / 60);
  const minutes = mins % 60;
  if (hours === 0) {
    return `${minutes} Mins`;
  }
  return `${hours} Hrs ${minutes} Mins`;
};

export const getGradientByValue = (val, gradientArr) => {
  if (val <= 30) return gradientArr[0];
  if (val <= 70) return gradientArr[1];
  return gradientArr[2];
};

export const dateFormatter = (item) => {
  const d = new Date(item?.date);
  const day = d.getDate().toString().padStart(2, "0");
  const month = d.toLocaleString("en-US", {
    month: "short",
  });
  const year = d.getFullYear().toString().slice(-2);
  return `${day} ${month} ${year}`;
};

export const getFromDate = (daysBack) => {
  return new Date(Date.now() - daysBack * 24 * 60 * 60 * 1000).getTime();
};

export const getToDate = () => {
  return new Date().getTime();
};

export const formatINRCurrency = (amount) => {
  if (!amount || typeof amount !== "number") return "-";
  const formatter = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  // Format the amount and insert a space after the ₹ symbol
  return formatter.format(amount).replace("₹", "₹ ");
};

export const formatINRNumber = (amount) => {
  return new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount);
};
export const formatRank = (rank) => {
  if (!rank || typeof rank !== "number") return `-`;
  const j = rank % 10,
    k = rank % 100;
  if (j === 1 && k !== 11) return `${rank}st`;
  if (j === 2 && k !== 12) return `${rank}nd`;
  if (j === 3 && k !== 13) return `${rank}rd`;
  return `${rank}th`;
};
